import { render, staticRenderFns } from "./avatars.vue?vue&type=template&id=b7d6055c&"
import script from "./avatars.vue?vue&type=script&lang=js&"
export * from "./avatars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports